import React from 'react';

const Hero = ({ lang = 'ar' }) => {
  const content = {
    ar: {
      title: "الوكيل للمحاماة والاستشارات القانونية",
      subTitle: "   شريكك القانوني الأمثل",
      cta: "احجز استشارتك الآن",
    },
    en: {
      title: "EL-WAKIL",
      subTitle:
        "Premier Legal Premier Legal Counsel Providing Strategic, Business-Focused Legal Solutions.Counsel & Strategic Vision",
      cta: "Book Consultation",
    },
  };

  const t = content[lang];
  const isAr = lang === 'ar';

  return (
    <section className="hero-section" dir={isAr ? 'rtl' : 'ltr'}>
      {/* الخلفية المظلمة */}
      <div className="hero-bg"></div>
      
      <div className="container">
        <div className="hero-content">
          {/* خط زخرفي صغير فوق العنوان */}
          <div className="decoration-line"></div>
          
          <h1 className="hero-title">
            {t.title}
          </h1>
          
          <p className="hero-subtitle">
            {t.subTitle}
          </p>

          <div className="btn-wrapper">
            <a href="#contact" className="premium-btn">
              <span>{t.cta}</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;